import type { RouteRecordRaw } from 'vue-router'
import { Layout } from '@/utils/routerHelper'

const gameRoutes: RouteRecordRaw[] = [
  {
    path: '/game',
    name: 'Game',
    component: Layout,
    meta: {
      title: '游戏配置',
      icon: 'vi-ep:monitor',
      alwaysShow: true
    },
    children: [
      {
        path: 'list',
        component: () => import('@/views/Game/GameList.vue'),
        name: 'GameList',
        meta: { title: '游戏列表' }
      },
      {
        path: 'config',
        component: () => import('@/views/Game/GameConfigList.vue'),
        name: 'GameConfigList',
        meta: { title: '参数配置' }
      },
      {
        path: 'level_config',
        component: () => import('@/views/Game/GameLevelConfigList.vue'),
        name: 'GameLevelConfigList',
        meta: { title: '等级配置' }
      },
      {
        path: 'field_config',
        component: () => import('@/views/Game/GameFieldConfigList.vue'),
        name: 'GameFieldConfigList',
        meta: { title: '场型配置' }
      },
      {
        path: 'online_count',
        component: () => import('@/views/Game/GameOnlineCountList.vue'),
        name: 'GameOnlineCountList',
        meta: { title: '在线人数' }
      },
      {
        path: 'match_instance',
        component: () => import('@/views/Game/GameMatchInstanceList.vue'),
        name: 'GameMatchInstanceList',
        meta: { title: '滚动场次' }
      }
    ]
  },
  {
    path: '/game-record',
    name: 'GameRecord',
    component: Layout,
    meta: {
      title: '游戏记录',
      icon: 'vi-ep:document',
      alwaysShow: true
    },
    children: [
      {
        path: 'exchange',
        component: () => import('@/views/Game/GameExchangeList.vue'),
        name: 'GameExchangeList',
        meta: { title: '兑换记录' }
      },
      {
        path: 'battle',
        component: () => import('@/views/Game/GameBattleList.vue'),
        name: 'GameBattleList',
        meta: { title: '对战记录' }
      },
      {
        path: 'match_record',
        component: () => import('@/views/Game/MatchRecordList.vue'),
        name: 'GameMatchRecordList',
        meta: { title: '报名记录' }
      },
      {
        path: 'group_record',
        component: () => import('@/views/Game/GroupList.vue'),
        name: 'GameGroupList',
        meta: { title: '分组记录' }
      }
    ]
  }
]

export default gameRoutes
